import { useCallback, useEffect, useRef, useState } from "react";

export function successfulScanKeys(submitted, result) {
  // New servers report indices, so two scans of the same card can have different
  // outcomes (e.g. different storage locations). Retain failures for retry.
  const failed = new Set(result.failed_indices ?? []);
  const failedCards = new Set(result.failed ?? []);
  return new Set(submitted.filter((item, index) => result.failed_indices
    ? !failed.has(index)
    : !failedCards.has(item.matches[item.sel].card_id)).map((item) => item.key));
}

export function useScanQueue() {
  const [queue, setQueue] = useState([]);
  const thumbnails = useRef(new Map());

  const enqueue = useCallback((key, blob) => {
    const thumb = URL.createObjectURL(blob);
    thumbnails.current.set(key, thumb);
    setQueue((items) => [{ key, thumb, status: "scanning", matches: [], sel: 0, qty: 1, variant: "normal" }, ...items]);
  }, []);

  const patch = useCallback((key, changes) => {
    setQueue((items) => items.map((item) => item.key === key ? { ...item, ...changes } : item));
  }, []);

  useEffect(() => {
    const currentKeys = new Set(queue.map((item) => item.key));
    for (const [key, url] of thumbnails.current) {
      if (!currentKeys.has(key)) {
        URL.revokeObjectURL(url);
        thumbnails.current.delete(key);
      }
    }
  }, [queue]);

  useEffect(() => {
    const urls = thumbnails.current;
    return () => {
      for (const url of urls.values()) URL.revokeObjectURL(url);
      urls.clear();
    };
  }, []);

  return { queue, setQueue, enqueue, patch };
}
